import axios from 'axios';
import { config } from '../config/environment';

export const GATEWAY = config.gatewayUrl;
export const TOKEN_KEY = 'admin_token';

const client = axios.create({
  baseURL: GATEWAY,
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export function apiErrorMessage(err: unknown): string {
  if (axios.isAxiosError(err)) {
    const data: any = err.response?.data;
    if (data?.message) return data.message;
    if (data?.error) return typeof data.error === 'string' ? data.error : 'Request failed';
    if (err.response) return `Request failed (${err.response.status})`;
    return 'Network error — could not reach the server';
  }
  if (err instanceof Error) return err.message;
  return 'Something went wrong';
}

export default client;
